import api from './api';

const countryService = {
  // Get all countries with optional filters
  getAllCountries: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.vatRequired) params.append('vatRequired', filters.vatRequired);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);

    return api.get(`/countries${params.toString() ? '?' + params.toString() : ''}`);
  },

  // Get a single country by code
  getCountryByCode: (code) => {
    return api.get(`/countries/${code}`);
  }
};

export default countryService;
